export function setCamino(state, camino) {
    state.camino = camino;
}

export function setCaminos(state, caminos) {
    state.caminos = caminos;
}

export function setAgencias(state, agencias) {
    state.agencias = agencias;
}

export function setAgencia(state, agencia) {
    state.agencia = agencia;
}

export function setLanguageSelected(state, language) {
    state.languageSelected = language.toLowerCase();
}
